import { render } from "./IndexBasic.vue?vue&type=template&id=05fa705d&scoped=true"
import script from "./IndexBasic.vue?vue&type=script&lang=js"
export * from "./IndexBasic.vue?vue&type=script&lang=js"

import "./IndexBasic.vue?vue&type=style&index=0&id=05fa705d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05fa705d"

export default script